const UTMCookies = require("./utilities/UTMCookies");
const StepUpYourGameOrContactUsForm = require("./components/form/StepUpYourGameOrContactUsForm");
const SecondaryDemoForm = require("./components/form/SecondaryDemoForm");
const StateField = require("./components/form/StateField");
const $ = require('jquery');
const JointsBackgroundAnimation = require("./components/miscellaneous/JointsBackgroundAnimation");
const ItblBadgesSlider = require("./layout-blocks/ItblBadgesSlider");
const MultiSelectForm = require("./components/form/MultiSelectForm");
const LoggerFactory = require("./utilities/LoggerFactory");
const ZoomInfo = require("./utilities/ZoomInfo");
const QuoteCarouselSlides = require("./components/miscellaneous/QuoteCarouselSlides");
const OnScrollAnimation = require("./utilities/OnScrollAnimation");
const NewProductBlock = require('./layout-blocks/NewProductBlock');
const JsonAnimation = require('./utilities/JsonAnimation');
const Slick = require('./utilities/Slick');
const QuoteCarouselHeightSetter = require('./utilities/QuoteCarouselHeightSetter');
const DemoEmailPrefill = require('./components/other/DemoEmailPrefill');
const GateStart = require('./components/gate/GateStart');
const ContentTabsWithImage = require('./components/other/ContentTabsWithImage');
const DemoFormShort = require('./components/form/DemoFormShort');
const ContactSalesForm = require('./components/form/ContactSalesForm');
const DownloadForm = require('./DownloadForm');
const DemioForm = require('./DemioForm');
const CustomerWebinarForm = require('./CustomerWebinarForm');
const PartnerForm1056 = require('./components/form/PartnerForm1056');
const ExpiesForm = require('./components/form/ExpiesForm');
const OneClickRegistrationButton = require('./utilities/OneClickRegistrationButton');
const CtaAfterSubmission = require('./utilities/CtaAfterSubmission');
const setupContactFormAccessibility = require('./utilities/setupContactFormAccessibility');
const FormController = require('./utilities/_form-controller');
const setupFormPopUpBox = require('./setupFormPopUpBox');
const EmailValidator = require("./utilities/EmailValidator");
require("./subscribe");
const whenThenMain = require("./src/main");

whenThenMain();

const loggerFactory = new LoggerFactory();

if (!(ITERABLE_MODULES in window)) {
  window.ITERABLE_MODULES = {};
}

window.ITERABLE_MODULES['$'] = $;

$(document).ready(() => {
	const utmCookies = new UTMCookies();
	StepUpYourGameOrContactUsForm.init(utmCookies);
	SecondaryDemoForm.init(utmCookies, loggerFactory);
	StateField.init();
	JointsBackgroundAnimation.init();
	ItblBadgesSlider.init();
	MultiSelectForm.init(utmCookies);
	JointsBackgroundAnimation.init();
	ItblBadgesSlider.init();

	$("#form-deckable2__download_form form").each(() => {
		new ZoomInfo(
			"c6e9ece9-9c27-4163-83e6-a9e4919f5bf5",
			"asset-download-form",
			"#form-deckable2__download_form form",
			"#form-deckable2__download_form [name='Email']",
			[
				'#form-deckable2__download_form [name="FirstName"]',
				'#form-deckable2__download_form [name="LastName"]',
				'#form-deckable2__download_form [name="Company"]',
				'#form-deckable2__download_form [name="Title"]',
			],
			loggerFactory
		);
	});

	$('[data-component="demo-multiform-deckable2"]').each(() => {
		new ZoomInfo(
			"ciTKO0bO4qa0piDSTXPq",
			"main-demo-form",
			'[data-component="demo-multiform-deckable2"]',
			'[data-component="demo-multiform-deckable2"] [name="Email"]',
			[
				'[data-component="demo-multiform-deckable2"] [name="FirstName"]',
				'[data-component="demo-multiform-deckable2"] [name="LastName"]',
				'[data-component="demo-multiform-deckable2"] [name="Company"]',
				'[data-component="demo-multiform-deckable2"] [name="Company_Size_Range__c"]'
			],
			loggerFactory
		);
	});

	$('[data-component="demo-form-short-form-tag"]').each((_, form) => {
		const zoomInfoFormId = "ciTKO0bO4qa0piDSTXPq";
		const formName = "demo-form-short";
		const uniqid = $(form).attr("data-uniqid");
		const formSelector = `[data-uniqid="${uniqid}"]`;
		const emailInputSelector = `${formSelector} [name="Email"]`;
		const autofillFieldSelectors = [
			formSelector + ' [name="FirstName"]',
			formSelector + ' [name="LastName"]',
			formSelector + ' [name="Company"]',
			formSelector + ' [name="Phone"]'
		];

		new ZoomInfo(zoomInfoFormId, formName, formSelector, emailInputSelector, autofillFieldSelectors, loggerFactory);
	});

	$('[data-component="quote-carousel-slides"]').each(function () {
		new QuoteCarouselSlides(`#${$(this).attr("id")}`);
	});

	$('[data-onscrollanimation]').each(function () {
		new OnScrollAnimation($(this));
	});

	$('[data-component="new-product-block"]').each(function () {
		window.newProductBlock = new NewProductBlock($(this));
	});

	UTMCookies.init();

	$('[data-component="json-animation"]').each(function () {
		new JsonAnimation($(this));
	});

	$('[data-component="slick"]').each(function () {
		new Slick($(this).attr('id'));
	});

	new QuoteCarouselHeightSetter();

	new DemoEmailPrefill();

	$('[data-component="gate-start"]').each(function () {
		new GateStart($(this).attr('id'));
	});

	$('[data-component="content-tabs-with-image"]').each(function () {
		new ContentTabsWithImage($(this).attr('id'));
	});

	$('[data-component="demo-form-short"]').each(function () {
		new DemoFormShort(this);
	});

	$('[data-component="contact-sales-form"]').each(function () {
		new ContactSalesForm(this);
	});

	$('.form-deckable2__download_form').each(function () {
		new DownloadForm($(this));
	});

	$('.itbl-plain-webinar-form').each(function () {
		new DemioForm($(this));
	});

	$('.itbl-component-customer-webinar-form').each(function () {
		new CustomerWebinarForm($(this));
	});

	$('[data-component="partner-form-1056"]').each(function () {
		new PartnerForm1056($(this).attr('id'), utmCookies);
	});

	$('[data-component="expies-form"]').each(function () {
		new ExpiesForm($(this).attr('id'), utmCookies);
	});

	const ctaAfterSubmission = new CtaAfterSubmission();

	$('[data-component="one-click-registration-button"]').each(function () {
		new OneClickRegistrationButton(ctaAfterSubmission, $(this).attr('id'));
	});

	$('[data-component="itbl-video-player"]').each(function () {
		const watchNowOverlay = this.querySelector('[data-component="watch-now-overlay"]');

		if (!watchNowOverlay) {
			return;
		} else {
			console.log("Watch now overlay not present in itbl-video-player");
		}

		const mqlAttributionInit = (playVideoCallback) => {
			const watchNowButton = watchNowOverlay.querySelector('[data-component="watch-now-button"]');
			if (watchNowButton) {
				watchNowOverlay.style.display = '';
				watchNowButton.addEventListener("click", async e => {
					let formData = {
						FirstName: 'Anonymous',
						LastName: 'Anonymous',
						Email: 'anonymous@iterable.com',
						Country: 'United States',
						State: 'Alaska',
						formid: "1134",
						munchkinId: "723-YAV-537"
					};

					const ctaAfterSubmission = new CtaAfterSubmission();
					formData = ctaAfterSubmission.loadFormData();
					formData['formid'] = '1134';
					formData['formVid'] = '1134';

					if ('Country' in formData) {
						if (formData['Country'] === 'United States') {
							if (!formData['State']) {
								formData['State'] = 'Alaska';
							}
						} else if (formData['Country'] === 'Canada') {
							if (!formData['State']) {
								formData['State'] = 'Alberta';
							}
						}
					}

					playVideoCallback();
					e.currentTarget.remove();
					watchNowOverlay.remove();

					try {
						if (window.location.hostname !== "localhost") {
							await FormController.marketo__submit(formData, undefined, undefined, undefined);
						} else {
							console.log("Marketo submit does not work in localhost, please test it in the staging environment! Skipping submission for now...");
						}
					} catch (e) {
						console.error("Failed to submit MQL attribution to Marketo!");
					}
				});
			}
		}

		const videoPlayer = document.querySelector('video.itbl-video-player-video');

		if (videoPlayer) {
			videoPlayer.style.width = '100%';
			videoPlayer.style.height = '100%';
			mqlAttributionInit(() => videoPlayer.play());
		}
	});

	const fixVideoPlayerDimension = () => {
	const videoPlayer = document.querySelector('video.itbl-video-player-video');
		if (videoPlayer) {
			videoPlayer.style.width = '100%';
			videoPlayer.style.height = '100%';
		}
	};

	fixVideoPlayerDimension();

	$('[data-component="activate-tour-save-the-date"]').each(function () {
		const $root = $(this);
		const dialogId = $root.data('dialogid');
		const $dialog = $(`#${dialogId}`);
		const $form = $dialog.find('form');
		const $stepper = $dialog.find('[data-component="activate-tour-save-the-date-stepper"]');

		const steps = $stepper.find('[data-component="step"]').length;

		// Country & privacy policy behavior
		const $marketingConsent = $form.find('[name=marketingConsent]');
		const $marketingConsentContainer = $form.find('[data-component="activate-tour-save-the-date-marketing-consent-container"]');
		const $country = $form.find('[name=Country]');
		$country.on("change", () => {
			const country = $country.val();
			if (country !== "United States") {
				$marketingConsent.prop("checked", false);
				$marketingConsentContainer.css({ display: '' });
			} else {
				$marketingConsent.prop("checked", false);
				$marketingConsentContainer.css({ display: 'none' });
			}
		});

		$form.on('submit', async e => {
			e.preventDefault();

			const serializedForm = $form.serializeArray();
			const formData = {};
			for (const property of serializedForm) {
				formData[property.name] = property.value;
			}

			const $formStep = $stepper.find('[data-component="form-step"]');
			const $loadingStep = $stepper.find('[data-component="loading-step"]');
			const $confirmationStep = $stepper.find('[data-component="confirmation-step"]');

			$formStep.css({ display: "none" });
			$loadingStep.css({ display: "" });
			$stepper.css({ transform: `translateX(${-100 * (1 / steps)}%)` });

			try {
				if (window.location.hostname !== "localhost") {
					await FormController.marketo__submit(formData, undefined, undefined, undefined);
				} else {
					console.log("Marketo submit does not work in localhost, please test it in the staging environment! Skipping submission...");
				}

				$confirmationStep.css({ display: "" });
				$stepper.css({ transform: `translateX(${-100 * (2 / steps)}%)` });
			} catch (e) {
				alert("Failed to submit form!");
				$formStep.css({ display: "" });
				$loadingStep.css({ display: "none" });
				$confirmationStep.css({ display: "none" });
				$stepper.css({ transform: `translateX(${-100 * (0 / steps)}%)` });
			}
		});
	});

	setupContactFormAccessibility();
	setupFormPopUpBox();

	window.itblFunctions.EmailValidator = EmailValidator;
});
